(() => {
  'use strict';
  const storageKey = 'powertoner-withdrawal-pending-v2';
  const maxAge = 30 * 60 * 1000;
  const readPending = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (saved && typeof saved.at === 'number' && Date.now() - saved.at >= 0 && Date.now() - saved.at < maxAge) return saved;
      sessionStorage.removeItem(storageKey);
    } catch (_) { /* The form still submits when browser storage is disabled. */ }
    return null;
  };
  function init(section) {
    if (section.dataset.wdReady) return;
    section.dataset.wdReady = 'true';
    const form = section.querySelector('.pt-withdrawal-form');
    if (!form) return;
    const success = form.querySelector('[data-wd-success]');
    if (success) {
      const saved = readPending();
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      if (saved && typeof saved.copy === 'string') {
        const wrapper = success.querySelector('[data-wd-copy]');
        wrapper.hidden = false;
        success.querySelector('[data-wd-copy-text]').textContent = saved.copy;
        success.querySelector('[data-wd-download]').addEventListener('click', () => {
          const url = URL.createObjectURL(new Blob(['\uFEFF' + saved.copy], {type: 'text/plain;charset=utf-8'}));
          const link = document.createElement('a');
          link.href = url; link.download = 'Powertoner-Widerruf.txt';
          document.body.append(link); link.click(); link.remove();
          setTimeout(() => URL.revokeObjectURL(url), 1000);
        });
      }
      success.focus();
      return;
    }
    const fields = Object.fromEntries(['name','email','order','scope','body'].map(key => [key, form.querySelector('[data-wd-' + key + ']')]));
    if (Object.values(fields).some(field => !field)) return;
    const inputs = form.querySelector('[data-wd-fields]');
    const review = form.querySelector('[data-wd-review]');
    const reviewButton = form.querySelector('[data-wd-review-button]');
    const editButton = form.querySelector('[data-wd-edit]');
    const submitButton = form.querySelector('[data-wd-submit]');
    const status = form.querySelector('[data-wd-status]');
    let reviewed = false, sending = false;
    const pending = readPending();
    if (pending?.values) Object.entries(fields).forEach(([key,field]) => { if (typeof pending.values[key] === 'string') field.value = pending.values[key]; });
    function edit() {
      reviewed = false;
      inputs.hidden = false; review.hidden = true;
      reviewButton.hidden = false; editButton.hidden = true; submitButton.hidden = true;
      Object.values(fields).forEach(field => { field.readOnly = false; });
    }
    function showReview() {
      Object.values(fields).forEach(field => {
        field.value = field.value.trim();
        field.setCustomValidity(field.value ? '' : 'Bitte fülle dieses Feld aus.');
      });
      if (!form.reportValidity()) return false;
      Object.entries(fields).forEach(([key,field]) => { review.querySelector('[data-wd-summary="' + key + '"]').textContent = field.value; field.readOnly = true; });
      reviewed = true;
      inputs.hidden = true; review.hidden = false;
      reviewButton.hidden = true; editButton.hidden = false; submitButton.hidden = false;
      review.focus();
      return true;
    }
    edit();
    reviewButton.addEventListener('click', showReview);
    editButton.addEventListener('click', () => { edit(); fields.name.focus(); });
    Object.values(fields).forEach(field => field.addEventListener('input', () => field.setCustomValidity('')));
    form.addEventListener('submit', event => {
      if (sending) { event.preventDefault(); return; }
      if (!reviewed) { event.preventDefault(); showReview(); return; }
      const at = Date.now();
      const stamp = new Date(at).toISOString();
      const reference = 'WD-' + (globalThis.crypto?.randomUUID?.() || at.toString(36) + '-' + Math.random().toString(36).slice(2,10));
      form.querySelector('[data-wd-timestamp]').value = stamp;
      form.querySelector('[data-wd-reference]').value = reference;
      const values = Object.fromEntries(Object.entries(fields).map(([key,field]) => [key,field.value]));
      const copy = ['KOPIE DEINER WIDERRUFSERKLÄRUNG', '', section.querySelector('.pt-wd-recipient').innerText, '', 'Referenz: ' + reference, 'Sendezeitpunkt laut Browser (UTC): ' + stamp, 'Name: ' + values.name, 'E-Mail-Adresse: ' + values.email, 'Bestellung: ' + values.order, 'Umfang: ' + values.scope, '', values.body, '', 'Die Übermittlung über das Kontaktformular wurde als erfolgreich angezeigt. Diese Kopie ersetzt keine gesonderte Eingangsbestätigung des Shops.'].join('\n');
      try { sessionStorage.setItem(storageKey, JSON.stringify({at,values,copy})); } catch (_) {}
      sending = true;
      status.textContent = 'Deine Erklärung wird übermittelt …';
      // Preserve Shopify's native submit and anti-spam handling; no custom fetch or false success state.
      setTimeout(() => { sending = false; status.textContent = 'Falls die Seite nicht weitergeleitet wurde, prüfe bitte eine angezeigte Sicherheitsabfrage oder versuche es erneut.'; }, 20000);
    });
    window.addEventListener('pageshow', event => { if (event.persisted) { sending = false; edit(); status.textContent = ''; } });
    form.querySelector('[data-wd-errors]')?.focus();
  }
  const scan = root => root.querySelectorAll('[data-withdrawal-section]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
